import api from '../api'
import filters from '@/filters'

/**
 * API插件
 * 使用方式：
 * 1. 在main.js中引入并使用此插件
 * 2. 在组件中通过this.$api.模块名.方法名()调用API
 */
export default {
  install(Vue) {
    // 将api挂载到Vue原型上，组件中可通过this.$api访问
    Vue.prototype.$api = api

    // 注册所有过滤器
    Object.keys(filters).forEach(key => {
      Vue.filter(key, filters[key])
    })

    // 也可以单独挂载某个模块，方便直接访问
    // Vue.prototype.$user = api.user
    // Vue.prototype.$article = api.article

    // 可以添加全局方法
    Vue.prototype.$http = {
      // 统一错误处理方法
      handleError(error) {
        console.error('API Error:', error)
        // 可以添加全局错误处理逻辑
      },
      
      // 统一成功处理方法
      handleSuccess(message) {
        console.log('API Success:', message)
        // 可以添加全局成功处理逻辑
      }
    }
  }
} 